import { useCurrentUserPermissions } from '../../components/CurrentUserPermissionsContext';

export function useHasPermission(permission: string | readonly string[]): boolean {
	const { hasPermission, isLoading } = useCurrentUserPermissions();
	const permissionIds = Array.isArray(permission) ? permission : [permission];

	return !isLoading && permissionIds.length > 0 && permissionIds.every(hasPermission);
}

export default useHasPermission;
